// src/theme/clientTheme.js

export const getClientTheme = (clientId) => {
  const themes = {
    1: {
      sidebarBg: "#166534",   // 🌿 Green
      hoverBg: "#15803D",
      activeBg: "#14532D",
      activeBorder: "#34D399",
      textColor: "#E6F4EC",
      iconColor: "#A7F3D0",
      headerText: "#14532D",
      activeTextColor: "#FFFFFF",
      darkColor:"#000",
    },
    2: {
      sidebarBg: "#7C2D12",   // 🌾 Brown
      hoverBg: "#9A3412",
      activeBg: "#89422a",
      activeBorder: "#FDBA74",
      textColor: "#FFF7ED",
      iconColor: "#FED7AA",
      headerText: "#7C2D12",
      activeTextColor: "#FFFFFF",
      darkColor:"#000",
    }
  };

  return themes[clientId] || themes[1]; // default theme
};